function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledFooterBottomBarLink } from "./footer-bottom-bar-link-component.scss";
import { FooterElementType } from "/constants/footer-element-types";
/**
 * Returns configuration objects for footer bottom bar link elements based on the element type.
 *
 * @param {Object} params - The parameters for configuring the element.
 * @param {string} params.url - The URL for anchor elements.
 * @param {function} params.onClick - The click handler for the element.
 * @param {string} params.customAttribute - Custom attribute for data-footer-link-type.
 * @returns {Object} An object mapping FooterElementType to their respective configuration objects.
 */ const getElementConfig = ({ url, onClick, customAttribute })=>({
        [FooterElementType.BUTTON]: {
            as: "button",
            type: "button",
            className: "footer-bottom-bar-link-component footer-button-as-link",
            onClick,
            "data-footer-link-type": customAttribute
        },
        [FooterElementType.ANCHOR]: {
            className: "footer-bottom-bar-link-component",
            href: url,
            onClick,
            "data-footer-link-type": customAttribute
        }
    });
const FooterBottomBarLink = (props)=>{
    const { title, url, translate, onClick, customAttribute, elementType } = props;
    const onLinkClick = (event)=>onClick === null || onClick === void 0 ? void 0 : onClick(event);
    const elementConfigs = getElementConfig({
        url,
        onClick: onLinkClick,
        customAttribute
    });
    const config = elementConfigs[elementType || FooterElementType.ANCHOR];
    return /*#__PURE__*/ _jsx(StyledFooterBottomBarLink, _object_spread_props(_object_spread({}, config), {
        children: translate(title)
    }));
};
export default withGenericConfig(FooterBottomBarLink);
